import { Box, Chip, Skeleton } from "@mui/material";
import { getBusinessColorByName } from "../utils/availabilityHelpers";
import { useAvailabilities } from "../AvailabilitiesProvider";

interface ItemSelectorProps {
  itemNames: string[];
  isExistingBookingLink: boolean;
}

const ItemSelector = ({
  itemNames,
  isExistingBookingLink,
}: ItemSelectorProps) => {
  const { isLoading, selectedItem, setSelectedItem, items } =
    useAvailabilities();

  const hasPrivateItems = items.some((item) =>
    item.availabilities.some((availability) => availability.private),
  );

  return (
    <Box
      sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}
    >
      <Chip
        key="all-businesses"
        label="All"
        onClick={() => setSelectedItem("All")}
        sx={{
          borderRadius: "16px",
          fontWeight: 500,
          cursor: "pointer",
          border: `1px solid ${selectedItem === "All" ? "#8D8D8D" : "#8D8D8D"}`,
        }}
      />

      {isLoading ? (
        [1, 2, 3, 4].map((i) => (
          <Skeleton
            key={i}
            variant="rounded"
            width={80}
            height={32}
            sx={{ borderRadius: "16px" }}
          />
        ))
      ) : (
        <>
          {itemNames.map((itemName) => {
            const colors = getBusinessColorByName(itemName);
            const isSelected = selectedItem === itemName;

            return (
              <Chip
                key={itemName}
                label={itemName}
                onClick={() => setSelectedItem(itemName)}
                sx={{
                  borderRadius: "16px",
                  fontWeight: 500,
                  cursor: "pointer",
                  color: isSelected ? colors.text : colors.text,
                  borderColor: colors.text,
                  backgroundColor: colors.bg,
                  border: `2px solid ${isSelected ? colors.text : colors.bg}`,
                }}
              />
            );
          })}
          {!isExistingBookingLink && hasPrivateItems && (
            <Chip
              key="direct-businesses"
              label="Direct links"
              onClick={() => setSelectedItem("Direct")}
              sx={{
                borderRadius: "16px",
                fontWeight: 500,
                cursor: "pointer",
                background: "#00000080",
                color: "#fff",
                border: `1px solid ${selectedItem === "Direct" ? "#00000080" : "#00000080"}`,
                "&:hover": {
                  color: "#00000080",
                },
              }}
            />
          )}
        </>
      )}
    </Box>
  );
};

export default ItemSelector;
